// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1COtO7upfGX0wIahg6pw7o {}\n\n._2FvGtmL-GArJVpaKvSiPBz + ._2FvGtmL-GArJVpaKvSiPBz {\n    margin-top: 16px;\n}\n\n._37qaK9XFJIsmPtJdy6hwY1 {\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 4px;\n    margin-bottom: 8px;\n    font-size: 16px;\n}\n\n._1AGdOMGCQ3URAGRSWET0Z8 {\n    line-height: 1.5;\n    font-size: 13px;\n}\n\n._1AGdOMGCQ3URAGRSWET0Z8 + ._1AGdOMGCQ3URAGRSWET0Z8 {\n    margin-top: 6px;\n}\n\n._32qHjv4kJTpBtVMKyDoVkx {\n    font-weight: 600;\n    display: block;\n}\n\n._9UWIXDz5A_VWH9CP24jgp {}\n\n._2A8r3oA8Eo-MFkHH5jwY-Z {\n    font-style: italic;\n    font-weight: 200;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_1COtO7upfGX0wIahg6pw7o",
	"group": "_2FvGtmL-GArJVpaKvSiPBz",
	"heading": "_37qaK9XFJIsmPtJdy6hwY1",
	"row": "_1AGdOMGCQ3URAGRSWET0Z8",
	"fieldName": "_32qHjv4kJTpBtVMKyDoVkx",
	"fieldData": "_9UWIXDz5A_VWH9CP24jgp",
	"fieldDataEmpty": "_2A8r3oA8Eo-MFkHH5jwY-Z"
};
module.exports = exports;
